// src/hooks/useAppleAuth.js
import { useState } from "react";
import { axiosWithCredentials } from "../api/axios";
import useAuth from "./useAuth";

export const useAppleAuth = (onSuccessCallback) => {
  const { sub } = useAuth();

  const [isAuthLoading, setIsAuthLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isErrorCompVisible, setIsErrorCompVisible] = useState(false);

  const handleAppleSuccess = async (response) => {
    // Apple returns:
    // response.authorization.id_token
    // response.user (ONLY sent on the FIRST login)

    const appleCredential = {
      identityToken: response.authorization?.id_token,
      user: response.user || null,
    };

    console.log("appleCredential", appleCredential);

    // Pass it directly to your pipeline function
    await executeAppleGuestSignup(appleCredential);
  };

  async function executeAppleGuestSignup(appleCredential) {
    if (isAuthLoading) return;

    try {
      setIsAuthLoading(true);

      const { identityToken, user } = appleCredential;

      const endpoint = sub
        ? "/convertGuestToAppleAuth/convertGuestToAppleAuth"
        : "/appleGuestAuth/appleGuestAuth";

      // STEP 1: Process Apple Guest Identity Authentication
      const authResponse = await axiosWithCredentials.post(endpoint, {
        id_token: identityToken,
        rawUser: user, // Sent by Apple SDK on initial sign-in
        ...(sub && { guestUserId: sub }),
      });

      const strictLocalToken = authResponse.data.accessToken;

      // STEP 2: Trigger success callback (e.g., setAuth & signupCompleted)
      if (onSuccessCallback) {
        onSuccessCallback(strictLocalToken);
      }

      // STEP 3: Close the authentication modal on success
    } catch (error) {
      console.error("Frontend Apple Auth Catch Triggered:", error);

      setErrorMessage(
        error?.response?.data?.message ||
          error.message ||
          "Apple authentication failed. Please try again.",
      );
      setIsErrorCompVisible(true);
    } finally {
      setIsAuthLoading(false);
    }
  }

  const handleAppleFailure = (error) => {
    console.error("Apple Sign-In Error:", error);
    setErrorMessage("Apple Sign-In Error");
    setIsErrorCompVisible(true);
  };

  return {
    handleAppleSuccess,
    handleAppleFailure,
    isAuthLoading,
    errorMessage,
    isErrorCompVisible,
    setIsErrorCompVisible,
  };
};
